import type { RotasDoModulo } from '@/app/rotas';

import { CreditSimulatorPage } from './CreditSimulatorPage';

/** Simulador de regras de credito (ADR 0083), dentro de Configuracoes. */
export const rotas: RotasDoModulo = {
  moldura: [
    { path: '/configuracoes/credito/simulador', element: <CreditSimulatorPage /> },
  ],
};
